import { Component } from '@angular/core';

@Component({
    templateUrl: 'tutorial.component.html'
})
export class TutorialComponent {

    public tourDone: Boolean = false;
}
